<template>
  <div class="card-filter">
    <el-row
      type="flex"
      align="start"
      justify="space-between"
      class="flex-wrap mb-l gap-12"
    >
      <el-row
type="flex"
align="middle">
        <el-select
          v-model="contractId"
          :placeholder="`Chọn quy trình`"
          class="w-100 mr-m"
          filterable
        >
          <el-option
            v-for="(contract, index) in allContracts"
            :key="index"
            :label="contract.name"
            :value="contract.id"
          />
        </el-select>
        <el-button
          size="medium"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchNormal"
        >
          Tìm kiếm
        </el-button>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CardFilter",
  props: {},
  data() {
    return {
      textSearch: "",
      contractId: ""
    };
  },
  computed: {
    ...mapGetters("contract", ["allContracts"]),
  },
  methods: {
    searchNormal() {
      this.$emit("search", {
        searchText: this.textSearch,
        contractId: this.contractId
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-filter {
  .text-search {
    min-width: 200px;
  }
}
</style>
